import React from "react";

const Faculty = () => {
  return (
      <div className="inline-block px-4 py-1 rounded-full bg-white/10 border border-white/20 text-sm tracking-wide mb-6">
          Coming Soon
        </div>
  );
};

export default Faculty;